export const ASSETS = {
    PLANTS: {
        PEASHOOTER: {
            key: 'peashooter',
            path: '/assets/images/plants/peashooter.png',
            frameWidth: 64,
            frameHeight: 64,
            frames: 15, // 总帧数
        },
        SUNFLOWER: {
            key: 'sunflower',
            path: '/assets/images/plants/sunflower.png',
            frameWidth: 64,
            frameHeight: 64,
            frames: 8,
        },
        WALLNUT: {
            key: 'wallnut',
            path: '/assets/images/plants/wallnut.png',
            frameWidth: 64,
            frameHeight: 64,
            frames: 8,
        },
    },
    ZOMBIES: {
        NORMAL: {
            key: 'basic_zombie',
            path: '/assets/images/zombies/basic_zombie.png',
            frameWidth: 80,
            frameHeight: 120,
            frames: 22, // 总帧数（行走 + 攻击）
        },
        CONE: {
            key: 'cone_zombie',
            path: '/assets/images/zombies/cone_zombie.png',
            frameWidth: 80,
            frameHeight: 120,
            frames: 22, // 总帧数（行走 + 攻击）
        },
        BUCKET: {
            key: 'bucket_zombie',
            path: 'assets/images/zombies/bucket_zombie.png',
            frameWidth: 64,
            frameHeight: 64,
            frames: 4,
        },
    },
    PROJECTILES: {
        PEA: {
            key: 'pea',
            path: '/assets/images/projectiles/pea.png',
            frameWidth: 16,
            frameHeight: 16,
        },
        SUN: {
            key: 'sun',
            path: '/assets/images/projectiles/sun.png',
            frameWidth: 40,
            frameHeight: 40,
        },
    },
    UI: {
        BACKGROUND: {
            key: 'background',
            path: '/assets/images/background/lawn.jpg',
            frameWidth: 800,
            frameHeight: 800,
        },

        SELECTBAR: {
            key: 'selectbar',
            path: '/assets/images/ui/selectbar.png',
        },
        CARD_BG: {
            key: 'card_background',
            path: '/assets/images/ui/card_background.png',
            frameWidth: 8,
            frameHeight: 8,
        },
    },
    EFFECTS: {
        SPLASH: {
            key: 'splash',
            path: '/assets/images/effects/splash.png',
            frameWidth: 32,
            frameHeight: 32,
            frames: 4,
        },
    },
};
